export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.22.3';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/browser/esm/version.js
// module id = 279
// module chunks = 92